// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'eina', 'eina Fallback'","fontWeight":400,"fontStyle":"normal"},"className":"__className_1dcf26","variable":"__variable_1dcf26"};